// Réglage des permissions d'un utilisateur non administrateur.
// groupes : catalogue renvoyé par GET /api/users/permissions.
// Une case dont le « parent » est décoché reste enregistrée mais est inactive
// (ex. « Gérer les chariots » sans l'onglet Colis).
export function PermissionsEditor({ groupes, value, onChange }) {
  const parentDe = {};
  groupes.forEach((g) => g.perms.forEach((p) => { parentDe[p.id] = p.parent || g.parent || null; }));
  const label = {};
  groupes.forEach((g) => g.perms.forEach((p) => { label[p.id] = p.label; }));
  const actif = (cle) => !parentDe[cle] || (!!value[parentDe[cle]] && actif(parentDe[cle]));
  const set = (cle, v) => onChange({ ...value, [cle]: v });
  const groupe = (g, v) => onChange({ ...value, ...Object.fromEntries(g.perms.map((p) => [p.id, v])) });

  return (
    <div className="space-y-3" data-testid="permissions-editor">
      {groupes.map((g) => {
        const off = !!g.parent && !(value[g.parent] && actif(g.parent));
        return (
          <fieldset key={g.id} className="rounded-lg border border-border p-3" data-testid={`perm-groupe-${g.id}`}>
            <legend className="px-1 text-xs font-semibold uppercase tracking-wider text-muted-foreground flex items-center gap-2">
              {g.label}
            </legend>
            {off && <p className="text-[11px] text-amber-600 dark:text-amber-400 -mt-1 mb-1.5">Sans effet tant que « {label[g.parent]} » n'est pas coché.</p>}
            <div className="grid sm:grid-cols-2 gap-x-4 gap-y-1.5">
              {g.perms.map((p) => {
                // Inactive : le « parent » (onglet ou page) n'est pas coché.
                const besoin = p.parent && !actif(p.id) ? label[p.parent] : null;
                return (
                  <label key={p.id} className="flex items-start gap-2 text-sm cursor-pointer leading-snug">
                    <input type="checkbox" className="w-4 h-4 mt-0.5 shrink-0 accent-[hsl(var(--primary))]" checked={!!value[p.id]}
                      onChange={(e) => set(p.id, e.target.checked)} data-testid={`perm-${p.id}`} />
                    <span className={besoin && !off ? "text-muted-foreground" : ""}>
                      {p.label}
                      {besoin && !off && <span className="block text-[11px]">nécessite « {besoin} »</span>}
                    </span>
                  </label>
                );
              })}
            </div>
            <div className="flex gap-3 mt-2 text-[11px]">
              <button type="button" className="text-primary hover:underline" onClick={() => groupe(g, true)}>Tout cocher</button>
              <button type="button" className="text-muted-foreground hover:underline" onClick={() => groupe(g, false)}>Tout décocher</button>
            </div>
          </fieldset>
        );
      })}
    </div>
  );
}
